import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router';

import { useDocumentTitle } from '@/hooks/useDocumentTitle';
import { useRootFontSize } from '@/hooks/useRootFontSize';
import { useRouteHandle } from '@/hooks/useRouteHandle';
import { scrollToHash } from '@/lib/scrollToHash';
import { useAuthStore } from '@/stores/auth';

/**
 * 루트 레이아웃 — 세션 부팅 복원, 문서 타이틀, 글자 크기 선호, 스크롤 동작(경로 변경 시 최상단 / 해시는 정착 후 스크롤).
 */
export function RootLayout() {
  const { pathname, hash } = useLocation();
  const { title } = useRouteHandle();
  const restoreSession = useAuthStore((s) => s.restoreSession);
  useDocumentTitle(title);
  useRootFontSize();

  useEffect(() => {
    void restoreSession();
  }, [restoreSession]);

  useEffect(() => {
    if (hash) scrollToHash(hash);
    else window.scrollTo({ top: 0 });
  }, [pathname, hash]);

  return <Outlet />;
}
